import { createContext } from "react";

const FormDataContext = createContext(undefined);

export default FormDataContext;
